import { FC, useContext } from 'react';
import { Button, Stack, Textarea } from '@chakra-ui/react';

import { UseOpenCloseReturn } from '~/core/hooks/useOpenClose';
import { useApplicationLixiXml } from '~/core/shared/api/middle-office/application/hooks/useApplicationLixiXml';
import { Dialog } from '~/core/shared/components';
import {
  ApplicationContext,
  DocumentDetailsViewActionContext,
} from '../Layout.component';

export const LixiXMLModal: FC = () => {
  const { actionContexts, applicationUuid, definition } =
    useContext(ApplicationContext);

  const {
    action: { key },
  } = useContext(DocumentDetailsViewActionContext);

  const lixiXMLModalApi: UseOpenCloseReturn = actionContexts[key].modal;

  const { lixiXml } = useApplicationLixiXml(applicationUuid, definition, {
    enabled: lixiXMLModalApi.open,
  });

  return (
    <Dialog
      header="Lixi XML"
      onOpenChange={lixiXMLModalApi.onOpenChange}
      open={lixiXMLModalApi.open}
      size="lg"
    >
      <Stack gap={4} p={6}>
        <Textarea
          minH="400"
          overflow="scroll"
          value={lixiXml}
          whiteSpace="pre"
        />
        <Stack direction="row" justifyContent="end">
          <Button
            colorPalette="gray"
            fontSize="md"
            fontWeight="normal"
            onClick={lixiXMLModalApi.onClose}
            variant="outline"
          >
            Close
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
};
